<template>
  <b-container fluid>
  <b-overlay :show="loading">
    <iq-card>
    <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('externalUser.view_resume') }}</h4>
    </template>
    <template v-slot:headerAction>
        <b-button variant="primary" @click="pdfExport" style="margin-left: 76%;margin-right: 10px;z-index:100;">
            Export  Pdf
        </b-button>
    </template>
    </iq-card>
    <b-row style="background-color:white;margin-left: 0px;">
        <div class="col-12" style="color:black;padding-left: 92px;">
            <h4 style="color:#333399;text-transform: uppercase;">{{ $i18n.locale === 'bn' ? personal.name : personal.name_bn }}</h4>
        </div>
        <b-row style="width: 79%;height: 115px;">
        <b-col lg="10" offset="1">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 20%;color:black;border:none;" class="text-left pl-4 " >{{$t('externalUser.mobile_no')}}</td>
                    <td class="text-center" style="width: 5%;color:black;border:none;">:</td>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{personal.mobile}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 20%;color:black;border:none;"  class="text-left pl-4 " >{{$t('externalUser.email')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{ $i18n.locale === 'bn' ? personal.name : personal.name_bn }}@gmail.com</td>
                </b-tr>
                <b-tr style="visibility:hidden;">
                    <td style="width: 20%;color:black;border:none;"  class="text-left pl-4 " >{{$t('retailerManagement.nid')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{ $n(personal.nid, { useGrouping: false }) }}</td>
                </b-tr>
                <b-tr style="visibility:hidden;">
                    <td style="width: 20%;color:black;border:none;"  class="text-left pl-4 " >{{$t('production_service_config.reg_date')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{ personal.registration_date | dateFormat }}</td>
                </b-tr>
            </table>
        </b-col>
        <b-col lg="4" style="color: black;transform: translate(797px, -165px);">
                <div class="">
                <b-img width="200px" style="margin-top: -31px!important;width: 116px;" class="mt-2" :src="awarenessEventServiceBaseUrl + '/storage/' + personal.photo" alt="Responsive image"></b-img>
                </div>
        </b-col>
        </b-row>
        <div class="BDJHeadline01 row" role="heading" aria-level="2" style="text-align:left;margin: 10px 15px 5px 0px;width: 100%;margin-left: 67px;">
            <em style="margin-left:30px;color:black;text-decoration: underline;font-style: normal;">{{$t('externalUser.personal_information')}}</em>
        </div>
        <b-row style="width: 79%;">
        <b-col lg="10" offset="1">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 20%;color:black;border:none;" class="text-left pl-4 " >{{$t('externalUser.father_name')}}</td>
                    <td class="text-center" style="width: 5%;color:black;border:none;">:</td>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{ $i18n.locale === 'bn' ? personal.father_name_bn : personal.father_name }}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 20%;color:black;border:none;"  class="text-left pl-4 " >{{$t('externalUser.mother_name')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{ $i18n.locale === 'bn' ? personal.mother_name_bn : personal.mother_name }}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 20%;color:black;border:none;"  class="text-left pl-4 " >{{$t('retailerManagement.nid')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{ $n(personal.nid, { useGrouping: false }) }}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 20%;color:black;border:none;"  class="text-left pl-4 " >{{$t('production_service_config.reg_date')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{ personal.registration_date | dateFormat }}</td>
                </b-tr>
            </table>
        </b-col>
        </b-row>
        <div class="BDJHeadline01 row" role="heading" aria-level="2" style="text-align:left;margin: 10px 15px 5px 0px;width: 100%;margin-left: 67px;">
            <em style="margin-left:30px;color:black;text-decoration: underline;font-style: normal;">{{$t('externalUser.employment_history')}}</em>
        </div>
        <table style="width: 90%;margin-left: 75px;">
        <tr>
            <th>{{$t('externalUser.company_name')}}</th>
            <th>{{$t('externalUser.company_business')}}</th>
            <th>{{$t('externalUser.designation')}}</th>
            <th>{{$t('externalUser.department')}}</th>
            <th>{{$t('externalUser.start_date')}}</th>
            <th>{{$t('externalUser.end_date')}}</th>
            <th>{{$t('externalUser.responsibilities')}}</th>
            <th>{{$t('externalUser.company_location')}}</th>
            <th>{{$t('externalUser.skill_info')}}</th>
        </tr>
        <tr v-for="(item,index) in job" :key="index">
            <td>{{ item.lang === 'bn' ? item.company_name_bn : item.company_name_en }}</td>
            <td>{{ item.lang === 'bn' ? item.company_business_bn : item.company_business_en }}</td>
            <td>{{ item.lang === 'bn' ? item.designation_bn : item.designation_en }}</td>
            <td>{{ item.lang === 'bn' ? item.department_bn : item.department_en }}</td>
            <td>{{ item.start_date | dateFormat }}</td>
            <td>{{ item.end_date | dateFormat }}</td>
            <td>{{ item.lang === 'bn' ? item.responsibilities_bn : item.responsibilities_en }}</td>
            <td>{{ item.lang === 'bn' ? item.company_location_bn : item.company_location_en }}</td>
            <td><span v-for="(itemm,index) in item.objOfJson" v-bind:key="index">{{itemm.skill}},</span></td>
        </tr>
        </table>
        <div class="BDJHeadline01 row" role="heading" aria-level="2" style="text-align:left;margin: 10px 15px 5px 0px;width: 100%;margin-left: 67px;">
            <em style="margin-left:30px;color:black;text-decoration: underline;font-style: normal;">{{$t('externalUser.academic_qualification')}}</em>
        </div>
        <table style="width: 90%;margin-left: 75px;">
        <tr>
            <th>{{$t('externalUser.level_of_education')}}</th>
            <th>{{$t('externalUser.degree_title')}}</th>
            <th>{{$t('externalUser.group')}}</th>
            <th>{{$t('externalUser.board')}}</th>
            <th>{{$t('externalUser.institute_name')}}</th>
            <th>{{$t('externalUser.result')}}</th>
            <th>{{$t('externalUser.cgpa')}}</th>
            <th>{{$t('externalUser.scale')}}</th>
            <th>{{$t('externalUser.year_of_passing')}}</th>
            <th>{{$t('externalUser.duration')}}</th>
            <th>{{$t('externalUser.achievement')}}</th>
        </tr>
        <tr v-for="(item,index) in educational" :key="index">
            <td>{{item.educationName}}</td>
            <td>{{ item.lang === 'bn' ? item.degree_title_bn : item.degree_title_en }}</td>
            <td>{{ item.lang === 'bn' ? item.group_name_bn : item.group_name_en }}</td>
            <td>{{item.board}}</td>
            <td>{{ item.lang === 'bn' ? item.institute_name_bn : item.institute_name_en }}</td>
            <td>{{ $n(item.result, { useGrouping: false })}}</td>
            <td>{{ $n(item.cgpa, { useGrouping: false })}}</td>
            <td>{{ $n(item.scale, { useGrouping: false })}}</td>
            <td>{{ $n(item.year_of_passing, { useGrouping: false })}}</td>
            <td>{{item.duration}}</td>
            <td>{{item.achievement}}</td>
        </tr>
        </table>
        <div class="BDJHeadline01 row" role="heading" aria-level="2" style="text-align:left;margin: 10px 15px 5px 0px;width: 100%;margin-left: 67px;">
            <em style="margin-left:30px;color:black;text-decoration: underline;font-style: normal;">{{$t('externalUser.present_address')}}</em>
        </div>
        <b-row style="width: 100%;" v-if="personal.pm_area_type_id === 1">
        <b-col lg="5" offset="1">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 28%;color:black;border:none;" class="text-left pl-4 " >{{$t('retailerManagement.division')}}</td>
                    <td class="text-center" style="width: 5%;color:black;border:none;">:</td>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pm_divisionText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('retailerManagement.district')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pm_districtText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('production_service_config.address')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{ $i18n.locale === 'bn' ? personal.pm_address_en : personal.pm_address_bn }}</td>
                </b-tr>
            </table>
        </b-col>
        <b-col lg="6">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('production_service_config.city_corporation_id')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pm_cityCorporationText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('org_pro.ward')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pm_wardText}}</td>
                </b-tr>
            </table>
        </b-col>
        </b-row>
        <b-row style="width: 100%;" v-if="personal.pm_area_type_id === 2">
        <b-col lg="5" offset="1">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 28%;color:black;border:none;" class="text-left pl-4 " >{{$t('retailerManagement.division')}}</td>
                    <td class="text-center" style="width: 5%;color:black;border:none;">:</td>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pm_divisionText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('retailerManagement.district')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pm_districtText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('production_service_config.address')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{ $i18n.locale === 'bn' ? personal.pm_address_en : personal.pm_address_bn }}</td>
                </b-tr>
            </table>
        </b-col>
        <b-col lg="6">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 20%;color:black;border:none;"  class="text-left pl-4 " >{{$t('retailerManagement.upazilla')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{pm_upazilaText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 20%;color:black;border:none;"  class="text-left pl-4 " >{{$t('org_pro.pauroshoba')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{pm_municipalityText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('org_pro.ward')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pm_wardText}}</td>
                </b-tr>
            </table>
        </b-col>
        </b-row>
        <b-row style="width: 100%;" v-if="personal.pm_area_type_id === 3">
        <b-col lg="5" offset="1">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 28%;color:black;border:none;" class="text-left pl-4 " >{{$t('retailerManagement.division')}}</td>
                    <td class="text-center" style="width: 5%;color:black;border:none;">:</td>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pm_divisionText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('retailerManagement.district')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pm_districtText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('production_service_config.address')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{ $i18n.locale === 'bn' ? personal.pm_address_en : personal.pm_address_bn }}</td>
                </b-tr>
            </table>
        </b-col>
        <b-col lg="6">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 20%;color:black;border:none;"  class="text-left pl-4 " >{{$t('retailerManagement.upazilla')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{pm_upazilaText}}</td>
                </b-tr>
            </table>
        </b-col>
        </b-row>
        <div class="BDJHeadline01 row" role="heading" aria-level="2" style="text-align:left;margin: 10px 15px 5px 0px;width: 100%;margin-left: 67px;">
            <em style="margin-left:30px;color:black;text-decoration: underline;font-style: normal;">{{$t('externalUser.permanent_address')}}</em>
        </div>
        <b-row style="width: 100%;" v-if="personal.pr_area_type_id === 1">
        <b-col lg="5" offset="1">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 28%;color:black;border:none;" class="text-left pl-4 " >{{$t('retailerManagement.division')}}</td>
                    <td class="text-center" style="width: 5%;color:black;border:none;">:</td>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pr_divisionText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('retailerManagement.district')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pr_districtText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('production_service_config.address')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{ $i18n.locale === 'bn' ? personal.pr_address_en : personal.pr_address_bn }}</td>
                </b-tr>
            </table>
        </b-col>
        <b-col lg="6">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('production_service_config.city_corporation_id')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pr_cityCorporationText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('org_pro.ward')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pr_wardText}}</td>
                </b-tr>
            </table>
        </b-col>
        </b-row>
        <b-row style="width: 100%;" v-if="personal.pm_area_type_id === 2">
        <b-col lg="5" offset="1">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 28%;color:black;border:none;" class="text-left pl-4 " >{{$t('retailerManagement.division')}}</td>
                    <td class="text-center" style="width: 5%;color:black;border:none;">:</td>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pr_divisionText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('retailerManagement.district')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pr_districtText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('production_service_config.address')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{ $i18n.locale === 'bn' ? personal.pr_address_en : personal.pr_address_bn }}</td>
                </b-tr>
            </table>
        </b-col>
        <b-col lg="6">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 20%;color:black;border:none;"  class="text-left pl-4 " >{{$t('retailerManagement.upazilla')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{pr_upazilaText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 20%;color:black;border:none;"  class="text-left pl-4 " >{{$t('org_pro.pauroshoba')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{pr_municipalityText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('org_pro.ward')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pr_wardText}}</td>
                </b-tr>
            </table>
        </b-col>
        </b-row>
        <b-row style="width: 100%;" v-if="personal.pr_area_type_id === 3">
        <b-col lg="5" offset="1">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 28%;color:black;border:none;" class="text-left pl-4 " >{{$t('retailerManagement.division')}}</td>
                    <td class="text-center" style="width: 5%;color:black;border:none;">:</td>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pr_divisionText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('retailerManagement.district')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{pr_districtText}}</td>
                </b-tr>
                <b-tr>
                    <td style="width: 28%;color:black;border:none;"  class="text-left pl-4 " >{{$t('production_service_config.address')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 67%;color:black;border:none;" class="text-left">{{ $i18n.locale === 'bn' ? personal.pr_address_en : personal.pr_address_bn }}</td>
                </b-tr>
            </table>
        </b-col>
        <b-col lg="6">
            <table style="border-collapse: collapse;border:none;">
                <b-tr>
                    <td style="width: 20%;color:black;border:none;"  class="text-left pl-4 " >{{$t('retailerManagement.upazilla')}}</td>
                    <th class="text-center" style="width: 5%;color:black;border:none;">:</th>
                    <td style="width: 75%;color:black;border:none;" class="text-left">{{pr_upazilaText}}</td>
                </b-tr>
            </table>
        </b-col>
        </b-row>
    </b-row>
    </b-overlay>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import flatpickr from 'flatpickr'
import { CvBankresumeViewApi } from '../../api/routes'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import custom from '@/store/custom'
import ExportPdf from './export-pdf_details'
import ExportPdfBN from './export-pdf_details_bangla'

export default {
  props: ['id'],
  components: {
  },
  created () {
      this.getCvData()
  },
  mounted () {
    core.index()
    flatpickr('#birth_date', {})
  },
  data () {
    return {
        CityCorpItemShow: false,
        personal: [],
        job: [],
        educational: [],
        PauroshobaItemShow: false,
        awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl,
        UnionItemShow: false,
        ItemShow: false,
        ItemShow2: false,
        CityCorpItemShow2: false,
        PauroshobaItemShow2: false,
        UnionItemShow2: false,
        isApproved: false,
        isMarried: false,
        saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
        profile: {
            id: '',
            name: '',
            name_bn: '',
            father_name: '',
            father_name_bn: '',
            mother_name: '',
            mother_name_bn: '',
            nid: '',
            birth_id: '',
            dss_id: '',
            mobile: '',
            marital_status: 2,
            gender: 1,
            disability_types: [],
            spouse_name: '',
            spouse_name_bn: '',
            birth_date: '',
            center_id: 0,
            service_type_id: 0,
            photo: [],
            signature: [],
            address: {
                pr_area_type_id: 0,
                pr_city_corporation_id: 0,
                pr_paurasabha_id: 0,
                pr_division_id: 0,
                pr_district_id: 0,
                pr_upazilla_id: 0,
                pr_union_id: 0,
                pr_ward_id: 0,
                pr_post_code: '',
                pr_post_office: '',
                pr_address_en: '',
                pr_address_bn: '',
                pm_area_type_id: 0,
                pm_city_corporation_id: 0,
                pm_paurasabha_id: 0,
                pm_division_id: 0,
                pm_district_id: 0,
                pm_upazila_id: 0,
                pm_union_id: 0,
                pm_ward_id: 0,
                pm_post_code: '',
                pm_post_office: '',
                pm_address_en: '',
                pm_address_bn: ''
            }
        },
        tmpPhoto: [],
        tmpSignature: [],
        districtList: [],
        upazilaList: [],
        unionList: [],
        cityCorporationList: [],
        pauroshobaList: [],
        wardList: [],
        districtList2: [],
        upazilaList2: [],
        unionList2: [],
        cityCorporationList2: [],
        pauroshobaList2: [],
        wardList2: [],
        centerList: [],
        pm_areaTypeName: '',
        pm_divisionText: '',
        pm_districtText: '',
        pm_cityCorporationText: '',
        pm_municipalityText: '',
        pm_upazillaText: '',
        pm_wardText: '',
        pr_areaTypeName: '',
        pr_divisionText: '',
        pr_districtText: '',
        pr_cityCorporationText: '',
        pr_municipalityText: '',
        pr_upazillaText: '',
        pr_wardText: '',
        education_level_name: ''
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    pdfExport () {
      const reportTitle = this.$t('production_service_config.dealer_info')
      const pdfMakeObj = {
        personal: this.personal,
        job: this.job,
        educational: this.educational,
        pm_divisionText: this.pm_divisionText,
        pm_districtText: this.pm_districtText,
        pm_upazilaText: this.pm_upazilaText,
        pm_cityCorporationText: this.pm_cityCorporationText,
        pm_wardText: this.pm_wardText,
        pr_divisionText: this.pr_divisionText,
        pr_districtText: this.pr_districtText,
        pr_upazilaText: this.pr_upazilaText,
        pr_cityCorporationText: this.pr_cityCorporationText,
        pr_wardText: this.pr_wardText,
        pm_areaTypeName: this.pm_areaTypeName,
        pr_areaTypeName: this.pr_areaTypeName
      }
      if (this.$i18n.locale === 'bn') {
        ExportPdfBN.exportPdfDetails(reportTitle, pdfMakeObj, this, this.awarenessEventServiceBaseUrl)
      } else {
        ExportPdf.exportPdfDetails(reportTitle, pdfMakeObj, this, this.awarenessEventServiceBaseUrl)
      }
    },
    async getCvData () {
            this.loading = true
            const store = this.$store
            const $i18n = this.$i18n
            const obj = {
              id: this.$route.query.patient_id
            }
            const result = await RestApi.getData(awarenessEventServiceBaseUrl, CvBankresumeViewApi, obj)
            if (result.success) {
                try {
            this.personal = result.personal
            this.job = result.job
            this.job.map(item => {
                item.lang = $i18n.locale === 'bn' ? 'bn' : 'en'
                item.objOfJson = JSON.parse(item.skill_info)
                const skills = []
                let skill = ''
                item.objOfJson.map(element => {
                    skill = store.state.AwarenessEventService.commonObj.skillList.find(obj => obj.value === element.skill_id)?.text_en
                    skills.push(skill)
                    element.skill = skill
                }
                )
                item.skill = skills.toString()
            })
            this.educational = result.education
            this.educational.map(item => {
                item.lang = $i18n.locale === 'bn' ? 'bn' : 'en'
                item.educationName = store.state.AwarenessEventService.commonObj.educationLevelList.find(obj => obj.value === item.education_level_id)?.text_en
            })
            if (this.$i18n.locale === 'bn') {
                    this.pm_divisionText = this.$store.state.commonObj.divisionList.find(document => document.value === result.personal.pm_division_id)?.text_bn
                    this.pm_districtText = this.$store.state.commonObj.districtList.find(document => document.value === result.personal.pm_district_id)?.text_bn
                    this.pm_upazilaText = this.$store.state.commonObj.upazilaList.find(document => document.value === result.personal.pm_upazila_id)?.text_bn
                    this.pm_cityCorporationText = this.$store.state.commonObj.cityCorporationList.find(item => item.value === result.personal.pm_city_corporation_id)?.text_bn
                    this.pm_wardText = this.$store.state.commonObj.wardList.find(item => item.value === result.personal.pm_ward_id)?.text_bn
                    this.pr_divisionText = this.$store.state.commonObj.divisionList.find(document => document.value === result.personal.pr_division_id)?.text_bn
                    this.pr_districtText = this.$store.state.commonObj.districtList.find(document => document.value === result.personal.pr_district_id)?.text_bn
                    this.pr_upazilaText = this.$store.state.commonObj.upazilaList.find(document => document.value === result.personal.pr_upazila_id)?.text_bn
                    this.pr_cityCorporationText = this.$store.state.commonObj.cityCorporationList.find(item => item.value === result.personal.pr_city_corporation_id)?.text_bn
                    this.pr_wardText = this.$store.state.commonObj.wardList.find(item => item.value === result.personal.pr_ward_id)?.text_bn
                    this.pm_areaTypeName = custom.wardTypeList.find(item => item.id === result.personal.pm_area_type_id)?.name_bn
                    this.pr_areaTypeName = custom.wardTypeList.find(item => item.id === result.personal.pr_area_type_id)?.name_bn
            } else {
                    this.pm_divisionText = this.$store.state.commonObj.divisionList.find(document => document.value === result.personal.pm_division_id)?.text_en
                    this.pm_districtText = this.$store.state.commonObj.districtList.find(document => document.value === result.personal.pm_district_id)?.text_en
                    this.pm_upazilaText = this.$store.state.commonObj.upazilaList.find(document => document.value === result.personal.pm_upazila_id)?.text_en
                    this.pm_cityCorporationText = this.$store.state.commonObj.cityCorporationList.find(item => item.value === result.personal.pm_city_corporation_id)?.text_en
                    this.pm_wardText = this.$store.state.commonObj.wardList.find(item => item.value === result.personal.pm_ward_id)?.text_en
                    this.pm_municipalityText = this.$store.state.commonObj.pauroshobaList.find(item => item.value === result.personal.pm_paurashabha_id)?.text_en
                    this.pr_divisionText = this.$store.state.commonObj.divisionList.find(document => document.value === result.personal.pr_division_id)?.text_en
                    this.pr_districtText = this.$store.state.commonObj.districtList.find(document => document.value === result.personal.pr_district_id)?.text_en
                    this.pr_upazilaText = this.$store.state.commonObj.upazilaList.find(document => document.value === result.personal.pr_upazila_id)?.text_en
                    this.pr_cityCorporationText = this.$store.state.commonObj.cityCorporationList.find(item => item.value === result.personal.pr_city_corporation_id)?.text_en
                    this.pr_wardText = this.$store.state.commonObj.wardList.find(item => item.value === result.personal.pr_ward_id)?.text_en
                    this.pr_municipalityText = this.$store.state.commonObj.pauroshobaList.find(item => item.value === result.personal.pm_paurashabha_id)?.text_en
                    this.pm_areaTypeName = custom.wardTypeList.find(item => item.id === result.personal.pm_area_type_id)?.name
                    this.pr_areaTypeName = custom.wardTypeList.find(item => item.id === result.personal.pr_area_type_id)?.name
            }
                } catch (e) {
                }
            } else {
            this.qualificationEducations = []
            }
            this.loading = false
      }
  }
}
</script>
<style>
.BDJHeadline01 {
    background: #E6E6E6;
    font-size: 12px;
    font-family: Verdana, Geneva, sans-serif;
    font-weight: bold;
    padding-left: 2px;
    padding-top: 2px;
    padding-bottom: 2px;
    width: 750px;
}
.BDJNormalText03 {
    background: #FFFFFF;
    font-size: 11px;
    font-family: Verdana, Geneva, sans-serif;
    font-weight: normal;
    padding-left: 7px;
    padding-top: 2px;
    padding-bottom: 2px;
}
table {
    margin-top: 20px;
    font-size: 11px;
    text-align: center;
    color: black;
    border:1px solid black;
}
th, td {
    border:1px solid black;
    padding-top:10px;
    padding-bottom: 10px;
}
.noborder {
    border: 0px!important;
}
</style>
